import { render, staticRenderFns } from "./partnerWithdrawal.vue?vue&type=template&id=6a01600e"
import script from "./partnerWithdrawal.vue?vue&type=script&lang=js"
export * from "./partnerWithdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports